import Grid from '../../components/UI/Grid/Grid';
import React from 'react';

const TariffContentList = props => {
    return (
        <div className="container-fluid card p-4 mb-5 animated fadeIn">
            <div className="row">
                <div className="col-12">
                    <h2 className="display-5">{props.listTitle}</h2>
                    <hr />
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <Grid
                        rowExpansionTemplate={props.rowExpansionTemplate}
                        onRowToggle={props.onRowToggle}
                        selectedRow={props.selectedRow}
                        expandDataKey={props.expandDataKey}
                        expandTable={props.expandTable}
                        columns={props.gridHeaders}
                        data={props.gridData}
                        hover={props.hover}
                        approveAction={props.approveAction}
                        rejectAction={props.rejectAction}
                    />
                </div>
            </div>
        </div>
    );
};

export default TariffContentList;
